import { IApplicationState } from '../../types/redux';

export function getBuilder(state: IApplicationState) {
  return state.newbuilding.builders[0];
}

export function getAdditionalBuilders(state: IApplicationState) {
  return state.newbuilding.builders.slice(1);
}
